import { useRef, useEffect } from "react";

// Magnetic wrapper: pulls its child toward the cursor within `radius`.
// Wrap primary CTAs with this. Falls back to zero effect on touch devices.
export default function Magnetic({ children, radius = 120, strength = 0.35, className = "" }) {
  const wrap = useRef(null);
  const inner = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || matchMedia("(pointer: coarse)").matches) return;
    const el = wrap.current;
    if (!el) return;

    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.hypot(dx, dy);
      if (dist < radius) {
        const pull = (1 - dist / radius) * strength;
        inner.current.style.transform = `translate3d(${dx * pull}px, ${dy * pull}px, 0)`;
      } else {
        inner.current.style.transform = "translate3d(0, 0, 0)";
      }
    };

    const onLeave = () => {
      inner.current.style.transform = "translate3d(0, 0, 0)";
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseleave", onLeave);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseleave", onLeave);
    };
  }, [radius, strength]);

  return (
    <span ref={wrap} className={`inline-block ${className}`}>
      <span ref={inner} className="inline-block transition-transform duration-500 ease-out will-change-transform">
        {children}
      </span>
    </span>
  );
}
